import { paxios } from 'util/axiosprgs';
import { RegulationRes, RegulationListRes, RegulationCreateReq, RegulationUpdateReq } from '../types/regulation.types';
import svcs from '../../../services';

export const useRegulationApi = () => {
  const getRegulation = async (id: number): Promise<RegulationRes> => {
    const response = await paxios.get(`/api/guest/zdata/regulation/${id}`);
    return response.data.data;
  };

  const getRegulationList = async (category: string, exposeSiteLanguage: string): Promise<RegulationListRes[]> => {
    const response = await paxios.get(`/api/guest/zdata/regulation/list`, { params: { category, exposeSiteLanguage } });
    return response.data.data;
  };

  const createRegulation = async (param: RegulationCreateReq): Promise<number> => {
    const response = await paxios.post(`/api/boris/zdata/regulation/create`, param);
    return response.data.data;
  };

  const updateRegulation = async (id: number, param: RegulationUpdateReq): Promise<number> => {
    const response = await paxios.put(`/api/boris/zdata/regulation/update/${id}`, param);
    return response.data.data;
  };

  const deleteRegulation = async (id: number): Promise<void> => {
    await paxios.delete(`/api/boris/zdata/regulation/delete/${id}`);
  };

  const uploadRegulationFiles = async (files: File[]): Promise<{ fileKey: string; fileName: string; fileSize: number; blobUrlForLargeFile?: string }[]> => {
    const key = `regulation/${Date.now()}`;
    const uploaded = await svcs.repoSsqData.postFileInBlob(key, files);
    const sizeByName = new Map(files.map((f) => [f.name, f.size]));
    return uploaded.map((f: { fileKey: string; fileName: string; blobUrlForLargeFile?: string }) => ({
      fileKey: f.fileKey,
      fileName: f.fileName,
      fileSize: sizeByName.get(f.fileName) ?? 0,
      blobUrlForLargeFile: f.blobUrlForLargeFile || undefined,
    }));
  };

  return {
    getRegulation,
    getRegulationList,
    createRegulation,
    updateRegulation,
    deleteRegulation,
    uploadRegulationFiles,
  };
};
